export const AUDIO_USER_GESTURE_EVENTS = ['pointerdown', 'keydown', 'click', 'touchstart'] as const;

/**
 * Capture so HUD/canvas handlers cannot swallow the unlock.
 * Leave the listener active so the browser treats it as audio user activation.
 */
export const AUDIO_USER_GESTURE_LISTENER_OPTIONS: AddEventListenerOptions = { capture: true };

const callbacks = new Set<() => void>();
let bound = false;

function onGesture(): void {
  for (const callback of [...callbacks]) {
    callback();
  }
}

function bindDocument(): void {
  if (bound) {
    return;
  }
  const root = globalThis.document;
  if (!root?.addEventListener || !root.removeEventListener) {
    return;
  }
  for (const type of AUDIO_USER_GESTURE_EVENTS) {
    root.addEventListener(type, onGesture, AUDIO_USER_GESTURE_LISTENER_OPTIONS);
  }
  bound = true;
}

function unbindDocument(): void {
  if (!bound) {
    return;
  }
  const root = globalThis.document;
  if (root?.removeEventListener) {
    for (const type of AUDIO_USER_GESTURE_EVENTS) {
      root.removeEventListener(type, onGesture, AUDIO_USER_GESTURE_LISTENER_OPTIONS);
    }
  }
  bound = false;
}

export function subscribeUserGestureUnlock(callback: () => void): () => void {
  callbacks.add(callback);
  bindDocument();
  return () => {
    callbacks.delete(callback);
    if (callbacks.size === 0) {
      unbindDocument();
    }
  };
}

export function resetUserGestureUnlockForTests(): void {
  callbacks.clear();
  unbindDocument();
}
